import { gql } from '@apollo/client';

export const GET_USER_INFO_FOR_HEADER = gql`
  query USER_SERVICE_getUserInfoForHeader {
    getUserInfoForHeader {
      firstName
      lastName
      affiliation
      sponsorId
      sponsorName
      userRoles
      imAgencyId
      agencyId
      agencyType
    }
  }
`;

export const GET_USER_NPN = gql`
  query USER_SERVICE_userByToken {
    userByToken {
      npn
    }
  }
`;

export const GET_AGENCY_ACCOUNT_REP = gql`
  query USER_SERVICE_getAgencyAccountRep {
    getAgencyAccountRep {
      email
    }
  }
`;

export const GET_USER_BY_ID = gql`
  query USER_SERVICE_userById($userId: String!) {
    userById(userId: $userId) {
      id
      firstName
      middleName
      lastName
      telephone
      email
    }
  }
`;

export const GET_AGENCY_STATUS = gql`
  query USER_SERVICE_getAgencyStatus($agencyId: String) {
    getAgencyStatus(agencyId: $agencyId)
  }
`;

export const INVITE_TO_SELF_ENROLL = gql`
  mutation USER_SERVICE_inviteToSelfEnroll($users: [InputSEUser]!) {
    inviteToSelfEnroll(users: $users) {
      id
      firstName
      middleName
      lastName
      telephone
      email
      status
      npn
      userTypes
      title
    }
  }
`;

export const SHARE_SELF_REGISTRATION_LINK = gql`
  mutation USER_SERVICE_shareSelfRegistrationLink($groupId: String!, $recipients: [String!]!, $message: String!) {
    shareSelfRegistrationLink(groupId: $groupId, recipients: $recipients, message: $message)
  }
`;

export const REMOVE_EMPLOYER = gql`
  mutation USER_SERVICE_removeEmployer($groupId: String!, $userId: String!) {
    removeEmployer(groupId: $groupId, userId: $userId)
  }
`;

export const UPDATE_EMPLOYER = gql`
  mutation USER_SERVICE_updateEmployer($user: InputEmployer!) {
    updateEmployer(user: $user) {
      id
      firstName
      middleName
      lastName
      telephone
      email
      status
      npn
      userTypes
      title
    }
  }
`;

export const GET_EMPLOYERS_FOR_GROUP = gql`
  query USER_SERVICE_getEmployersForGroup($groupId: String!) {
    getEmployersForGroup(groupId: $groupId) {
      id
      firstName
      middleName
      lastName
      telephone
      email
      status
      npn
      userTypes
      title
    }
  }
`;

export const USER_BY_TOKEN = gql`
  query USER_SERVICE_userByToken {
    userByToken {
      firstName
      lastName
      telephone
      npn
    }
  }
`;

export const EDIT_USER_INFORMATION = gql`
  mutation USER_SERVICE_editUserInformation($userInfo: UserInfo!) {
    editUserInformation(userInfo: $userInfo)
  }
`;

export const GET_CELTIC_USERS_FOR_SPONSOR_BY_TYPE = gql`
  query USER_SERVICE_getCelticUsersForSponsorByType($sponsorId: String, $type: CelticType!) {
    getCelticUsersForSponsorByType(sponsorId: $sponsorId, type: $type) {
      firstName
      lastName
      email
      id
    }
  }
`;

export const GET_SELF_REGISTRATION_LINK = gql`
  query USER_SERVICE_getSelfRegistrationLink($groupId: String!) {
    getSelfRegistrationLink(groupId: $groupId)
  }
`;

export const INVITE_EMPLOYEES_TO_GROUP = gql`
  mutation USER_SERVICE_inviteEmployeesToGroup(
    $groupId: String!
    $employees: [Map!]!
    $encrypted: Boolean = true
    $inviteType: InviteType = LINK
    $invite: Boolean = false
  ) {
    inviteEmployeesToGroup(
      groupId: $groupId
      employees: $employees
      encrypted: $encrypted
      inviteType: $inviteType
      invite: $invite
    )
  }
`;

export const INVITE_SUBSCRIBER = gql`
  mutation USER_SERVICE_inviteSubscriber($user: InputSEUser!) {
    inviteSubscriber(user: $user)
  }
`;

export const REINVITE_SUBSCRIBER = gql`
  mutation USER_SERVICE_reinviteSubscriber($user: InputSEUser!) {
    reinviteSubscriber(user: $user)
  }
`;

export const GET_PRODUCER_LIST_BY_AGENCY = gql`
  query USER_SERVICE_getProducerListByAgency($id: String!, $state: String) {
    getProducerListByAgency(id: $id, state: $state) {
      id
      name
      source
      appointedStates
      sponsorSpecificData
      status
    }
  }
`;
